var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"color":'#21AE8C'},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }